import React from 'react';
import styled from 'styled-components';

const Title = styled.h1`
  color: ${(props) => props.theme.colors.brandBlue};
  font-size: 40px;
  font-family: RobotoCondensed;
`;

export interface IPageTitleProps {
  text: string;
  style?: object;
}

const PageTitle = ({ text, style }: IPageTitleProps) => {
  return <Title style={style}>{text}</Title>;
};

export default PageTitle;
